export default __webpack_public_path__ + "static/media/bg_visa_01.2c6591e3.jpg";